"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var picture_icon_dark_svg_1 = __importDefault(require("res/img/picture-icon-dark.svg"));
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var CreateProductImages = function (_a) {
    var images = _a.images, onChange = _a.onChange, onDelete = _a.onDelete;
    var _b = react_1.useState([]), objectUrls = _b[0], setObjectUrls = _b[1];
    react_1.useEffect(function () {
        setObjectUrls(images.map(function (image) { return URL.createObjectURL(image); }));
        return function () {
            for (var _i = 0, objectUrls_1 = objectUrls; _i < objectUrls_1.length; _i++) {
                var url = objectUrls_1[_i];
                URL.revokeObjectURL(url);
            }
        };
    }, [images]);
    return (react_1.default.createElement("div", { className: 'create-product-images flex flex-column' },
        react_1.default.createElement("div", { className: 'create-product-images__upload flex flex-row' },
            react_1.default.createElement("img", { className: 'create-product-images__upload__icon', src: picture_icon_dark_svg_1.default, alt: 'Upload' }),
            react_1.default.createElement("span", null, "Upload Image/s"),
            react_1.default.createElement("input", { type: 'file', name: 'image', accept: 'image/jpg, image/jpeg, image/png, image/bmp, image/webp', multiple: true, onChange: onChange })),
        react_1.default.createElement("div", { className: 'create-product-images__thumbs flex flex-row flex-wrap thin-scroll' }, objectUrls.map(function (dataUrl, i) { return (react_1.default.createElement("div", { key: "gal_" + i, className: 'create-product-images__thumb' },
            react_1.default.createElement("img", { src: dataUrl, alt: 'Image Preview', className: 'create-product-images__thumb__preview' }),
            react_1.default.createElement("button", { type: 'button', title: 'Delete', onClick: function () { onDelete(i); }, "aria-label": 'Delete Image', className: 'flex flex-column flex-center' },
                react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Delete' })))); }))));
};
exports.default = CreateProductImages;
